import React from 'react';
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';
import { educationAuthTokenUrls } from 'services/Externals';


const RetailTracSSOErrorPage = ({ headline = 'We are having technical issues redirecting to your Small Business Retirement Plan account(s).' }) => {
    return (
        <ErrorPage summaryMessage={headline}>
            <div className="sso-form-error-message">
                Please <a className={'link'} href={educationAuthTokenUrls.contactUrl} target="_self" rel="noreferrer">contact us</a> or try again later.
            </div>
        </ErrorPage>
    );
};

export default RetailTracSSOErrorPage;
